var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import { GTMService } from "../../../../../mainDi/webDi";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { useEllipseDetection } from "@frameworks/web/utils/useEllipseDetection";
import { escapeRegexStr } from "@frameworks/web/utils/regex";
var ReadMoreText = function (_a) {
    var text = _a.text, className = _a.className, searchVal = _a.searchVal, exchange = _a.exchange, maxLength = _a.maxLength, tabName = _a.tabName, subtabName = _a.subtabName, highlightColor = _a.highlightColor, avoidUpperCase = _a.avoidUpperCase, _b = _a.showFullText, showFullText = _b === void 0 ? false : _b;
    var _c = __read(React.useState(!showFullText), 2), isReadMore = _c[0], setIsReadMore = _c[1];
    var arrowSpan = React.useRef();
    var isEllipseVisible = useEllipseDetection(arrowSpan);
    var _d = __read(React.useState(isEllipseVisible), 2), isEllipse = _d[0], setIsEllipse = _d[1];
    useEffect(function () {
        setIsEllipse(arrowSpan);
    }, []);
    var toggleReadMore = function (e) {
        e.stopPropagation();
        setIsReadMore(!isReadMore);
        isReadMore
            ? GTMService.gtmService(new ReportGAEvents("".concat(text), "".concat(ReportsGTMConstants.NewReports, " ").concat(tabName ? " | " + tabName : " ", " ").concat(subtabName ? " | " + subtabName : ""), "".concat(text)))
            : null;
    };
    var isSearchMatch = function (textVal) {
        if (searchVal && textVal !== null) {
            if (searchVal.includes("\\"))
                searchVal = searchVal.replace(/\\/g, "");
            searchVal = escapeRegexStr(searchVal);
            var parts = textVal === null || textVal === void 0 ? void 0 : textVal.split(new RegExp("(".concat(searchVal, ")"), "gi"));
            if (parts !== null)
                return (React.createElement("span", null, parts.map(function (part, i) { return (React.createElement("span", { key: i, style: part.toLowerCase() === searchVal.toLowerCase()
                        ? {
                            background: highlightColor ? highlightColor : "#F0F9FF",
                        }
                        : {} }, part)); })));
            else
                return textVal;
        }
        else
            return textVal;
    };
    return (React.createElement("div", { className: "name ".concat(className) },
        React.createElement("span", { ref: arrowSpan, className: "name-readmore ".concat(isReadMore ? "readmore-ellip" : "") },
            isReadMore && text != null
                ? !avoidUpperCase && isSearchMatch(text === null || text === void 0 ? void 0 : text.trim().toUpperCase())
                : !avoidUpperCase && isSearchMatch(text.toUpperCase()),
            avoidUpperCase && isReadMore && text != null
                ? isSearchMatch(text === null || text === void 0 ? void 0 : text.trim())
                : avoidUpperCase && isSearchMatch(text),
            exchange && (React.createElement("span", { className: "tag exchange" },
                exchange,
                " ",
                React.createElement("br", null)))),
        (text === null || text === void 0 ? void 0 : text.length) >= maxLength && isEllipse && (React.createElement("span", { onClick: toggleReadMore }, isReadMore ? (React.createElement("span", { className: "readmore" },
            React.createElement("i", { className: "edel-icon-double-arrow-right" }))) : (React.createElement("span", { className: "readmore" },
            React.createElement("i", { className: "edel-icon-double-arrow-left" })))))));
};
export default ReadMoreText;
